import React, { useState } from "react";
import Dropdown from "../components/Dropdown";
import Boxplot from "./Boxplot";
import Histogram from "./Histogram";

const UnivariatePlot = ({ plotdata, attributes, cat_attributes }) => {
  const int_plots = [
    { value: "box", label: "Box Plot" },
    { value: "line", label: "Line Plot" },
  ];

  const cat_plots = [{ value: "histogram", label: "Histogram Plot" }];

  // const tsa_plot = [{ value: "line", label: "TSA Plot" }];

  // const getLabel = (value) => {
  //   for (let i = 0; i < attributes.length; i++) {
  //     if (attributes[i].value === value) {
  //       return attributes[i].label;
  //     }
  //   }
  // };

  const getplotLabel = (value) => {
    for (let i = 0; i < int_plots.length; i++) {
      if (int_plots[i].value === value) {
        return int_plots[i].label;
      }
    }
  };
  const initialXAttribute = attributes[0].label;
  const [xAttribute, setXAttribute] = useState(initialXAttribute);
  // const xValue = (d) => d[xAttribute];
  // const xAxisLabel = getLabel(xAttribute);

  const initialCatAttribute = cat_attributes[0].label;
  const [catAttribute, setCatAttribute] = useState(initialCatAttribute);
  // const calValue = (d) => d[catAttribute];
  // const catLabel = getLabel(catAttribute);

  const initialplot = int_plots[0].value;
  const [plotAttribute, setPlotAttribute] = useState(initialplot);
  const plotAxisLabel = getplotLabel(plotAttribute);

  ////// cat plot
  const catplot = cat_plots[0].value;
  const [catplotAttribute, setCatPlotAtrrinbute] = useState(catplot);
  ///////////////

  const data = [];
  for (let i = 0; i < plotdata.length; i++) {
    data[i] = plotdata[i][xAttribute];
  }

  /// cat data
  const catdata = [];
  for (let i = 0; i < plotdata.length; i++) {
    catdata[i] = plotdata[i][catAttribute];
  }

  return (
    <>
      <div className="container">
        <div className="row me-5">
          <form className="text-center d-flex">
            <div className="col text-center d-flex mx-5">
              <h5>Plot For Integer columns:-</h5>
              &nbsp;&nbsp;
              <Dropdown
                options={attributes}
                id="x-select"
                selectedValue={xAttribute}
                onSelectedValueChange={setXAttribute}
              />
              &nbsp;&nbsp;
              <Dropdown
                options={int_plots}
                id="plots"
                selectedValue={plotAttribute}
                onSelectedValueChange={setPlotAttribute}
              />
            </div>

            <div className="col text-center d-flex">
              <h5>Plot For Category Columns:-</h5>
              &nbsp;&nbsp;
              <Dropdown
                options={cat_attributes}
                id="cat-select"
                selectedValue={catAttribute}
                onSelectedValueChange={setCatAttribute}
              />{" "}
              &nbsp;&nbsp;
              <Dropdown
                options={cat_plots}
                id="cat_plot"
                selectedValue={catplotAttribute}
                onSelectedValueChange={setCatPlotAtrrinbute}
              />
            </div>
          </form>
        </div>
        <br/><br/>
        <div className="d-flex">
          <div className="col px-2">
            <Boxplot plot={plotAttribute} data={data} name={xAttribute} plotname={plotAxisLabel}/>
          </div>

          <div className="col px-2">
            <Histogram
              plot={catplotAttribute}
              data={catdata}
              name={catAttribute}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UnivariatePlot;
